export const hasStoreEnabled = () => {
  return window.school && window.school.platform_version >= 2.8
}

export const getStoreUrl = (resourceSlug) => {
  let url = hasStoreEnabled() ? "/store/" : "/library/"
  if (resourceSlug) {
    url += resourceSlug
    url += hasStoreEnabled() ? "/" : "/about/"
  }
  return url
}

export const getStoreLabel = () => {
  return hasStoreEnabled() ? "Store" : "Library"
}
